import React, { useEffect, useState } from "react";
import { Row, Col, Card, Form, Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useNavigate, useParams, Link } from "react-router-dom";
import API from "../../../services/axiosInstance";
import Permission from "../../security/permission";
import { AUTH_CODE } from "../../security/authCodes";
import { FormLoader, useFormLoader } from "../../common_modules/loader";
import { LuPenLine } from "react-icons/lu";
const PublisherInfo = () => {
    const navigate = useNavigate();
    const [pubInfo, setPubInfo] = useState();
    const { register, reset, formState: { errors }, } = useForm();
    const { id, guid } = useParams();
    const { isLoading, startLoading, stopLoading } = useFormLoader(); // custom hook loader

    const pubInfoApi = async () => {
        startLoading();
        try {
            const res = await API.get(`/publisher/accounts/${guid}`);
            if (res.data.status === "Success") {
                const data = res?.data?.data;
                setPubInfo(data);
                console.log(data);
                reset({
                    name: data.name,
                    userId: data.userId,
                    payoneerId: data.payoneerId,
                    email: data.email,
                    phone: data.phone,
                    contactDetail: data.contactDetail,
                    companyName: data.companyName,
                    brand: data.brand,
                    city: data.city,
                    country: data.country,
                    address: data.address
                })
            }
        } catch (error) {
            alert(error?.res?.data?.message || "Something went wrong!");
        } finally {
            stopLoading();
        }
    }

    useEffect(() => {
        pubInfoApi();
    }, [guid, reset]);

    return (
        <FormLoader isLoading={isLoading} text={"Loading..."}>
            <div className="breadCrumb gradient-bg">
                <Link to={'/dashboard'}><span>Home</span></Link>
                {/* <Permission code={AUTH_CODE.accounts.publisherListing}> */}
                <Permission code={AUTH_CODE.accounts.publisherListing}>
                    <Link to={'/active-publisher'}><span>Publisher</span></Link>
                </Permission>
                {/* </Permission> */}
                <span>{pubInfo?.name} Information</span>
                {/* <span>Info</span> */}

            </div>
            <Card className="p-3 instreamRows">
                <div className="d-flex justify-content-between align-items-center mt-2 mb-3">
                    <h6 className="title" style={{ fontSize: "20px" }}>Account Information</h6>
                    <Permission code={AUTH_CODE.accounts.editUpdatePublisher}>
                        <Link to={`/publisher/edit/${id}/${guid}`} className="text-decoration-none fw-semibold activePubAllBtns" style={{ color: "#fff" }}>
                            <button className="mx-5">Edit Info <LuPenLine /></button>
                        </Link>
                    </Permission>
                </div>
                <Card className="p-3">
                    <h4 className="subTitle">User Information</h4>
                    {/* Account Name */}
                    <Row>
                        <Col md={3}>
                            <label>Account Name</label>
                        </Col>
                        <Col md={5}>
                            <div className="form-control bg-light"> {pubInfo?.name || "-"} </div>
                        </Col>
                    </Row>
                    {/* User ID */}
                    <Row>
                        <Col md={3}>
                            <label>User ID</label>
                        </Col>
                        <Col md={5}>
                            {/* <Form.Control type="text" placeholder="Enter here..." autoComplete="off" {...register("userId")} /> */}
                            <div className="form-control bg-light"> {pubInfo?.userId || "-"} </div>
                        </Col>
                    </Row>

                </Card>

                <Card className="p-3 mt-5">
                    <h6 className="subTitle">Contact Information</h6>
                    {/* Payoneer ID */}
                    <Row>
                        <Col md={3}>
                            <label>Payoneer ID</label>
                        </Col>
                        <Col md={5}>
                            {/* <Form.Control type="text" placeholder="Enter here..." {...register("payoneerId")} /> */}
                            <div className="form-control bg-light"> {pubInfo?.payoneerId || "-"} </div>
                        </Col>
                    </Row>
                    {/* Email ID */}
                    <Row>
                        <Col md={3}>
                            <label>Email ID</label>
                        </Col>
                        <Col md={5}>
                            {/* <Form.Control type="email" name="email" placeholder="Enter here..." {...register("email")} /> */}
                            <div className="form-control bg-light"> {pubInfo?.email || "-"} </div>
                        </Col>
                    </Row>
                    {/* Contact Number */}
                    <Row>
                        <Col md={3}>
                            <label>Contact Number</label>
                        </Col>
                        <Col md={5}>
                            {/* <Form.Control type="number" name="phone" placeholder="Enter here..." {...register("phone")} /> */}
                            <div className="form-control bg-light"> {pubInfo?.phone || "-"} </div>
                        </Col>
                    </Row>
                    {/* Contact Person Detail */}
                    <Row>
                        <Col md={3}>
                            <label>Contact Person Detail</label>
                        </Col>
                        <Col md={5}>
                            {/* <Form.Control type="text" name="contactDetail" placeholder="Enter here..." {...register("contactDetail")} /> */}
                            <div className="form-control bg-light"> {pubInfo?.contactDetail || "-"} </div>
                        </Col>
                    </Row>
                </Card>
                <Card className="p-3 mt-5">
                    <h6 className="subTitle">Company Information</h6>
                    {/* Contact Person Detail */}
                    <Row>
                        <Col md={3}>
                            <label>Company Name (legal name)</label>
                        </Col>
                        <Col md={5}>
                            {/* <Form.Control type="text" name="companyName" placeholder="Enter here..." {...register("companyName")} /> */}
                            <div className="form-control bg-light"> {pubInfo?.companyName || "-"} </div>
                        </Col>
                    </Row>
                    {/* Brand Name */}
                    <Row>
                        <Col md={3}>
                            <label>Brand Name</label>
                        </Col>
                        <Col md={5}>
                            {/* <Form.Control type="text" name="brand" placeholder="Enter here..." {...register("brand")} /> */}
                            <div className="form-control bg-light"> {pubInfo?.brand || "-"} </div>
                        </Col>
                    </Row>
                    {/* City Name */}
                    <Row>
                        <Col md={3}>
                            <label>City Name</label>
                        </Col>
                        <Col md={5}>
                            {/* <Form.Control type="text" name="city" placeholder="Enter here..." {...register("city")} /> */}
                            <div className="form-control bg-light"> {pubInfo?.city || "-"} </div>
                        </Col>
                    </Row>
                    {/* Country Name */}
                    <Row>
                        <Col md={3}>
                            <label>Country Name</label>
                        </Col>
                        <Col md={5}>
                            {/* <Form.Control type="text" name="country" placeholder="Enter here..." {...register("country")} /> */}
                            <div className="form-control bg-light"> {pubInfo?.country || "-"} </div>
                        </Col>
                    </Row>
                    {/* Company Address */}
                    <Row>
                        <Col md={3}>
                            <label>Company Address</label>
                        </Col>
                        <Col md={5}>
                            {/* <Form.Control as="textarea" rows={6} name="address" placeholder="Enter here..." {...register("address")} /> */}
                            <div className="form-control bg-light"> {pubInfo?.address || "-"} </div>
                        </Col>
                    </Row>
                </Card>
            </Card>
        </FormLoader>
    )
}

export default PublisherInfo;